import React from 'react';

export const ESPACO_ICONE_AJUDA = {
  marginLeft: 8,
  width: 18,
  flexShrink: 0,
};

const CampoComEspacoIconeAjuda = ({ children }) => (
  <div style={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
    <div style={{ flex: 1, minWidth: 0 }}>{children}</div>
    <span style={ESPACO_ICONE_AJUDA} aria-hidden="true" />
  </div>
);

export default CampoComEspacoIconeAjuda;
